const keywordConfig = [
	{
		keyword: 'Volvo-Selekt',
		aliases: ['volvoselekt', 'volvo-selekt', 'volvo selekt'],
		title: 'Volvo Selekt',
		description: 'Den har bilen ar en Volvo Selekt med kontrollerad kvalitet och extra trygghet.'
	},
	// {
	// 	keyword: 'Hemleverans',
	// 	aliases: ['hemleverans'],
	// 	title: 'Hemleverans',
	// 	description: 'Den har bilen kan levereras hem till dig for en enkel och smidig bilaffar.'
	// },
	// {
	// 	keyword: 'Dragkrok',
	// 	aliases: ['dragkrok'],
	// 	title: 'Dragkrok',
	// 	description: 'Den har bilen ar utrustad med dragkrok och ar redo for vardag och fritid.'
	// },
	// {
	// 	keyword: 'Fyrhjulsdrift',
	// 	aliases: ['fyrhjulsdrift', 'awd'],
	// 	title: 'Fyrhjulsdrift',
	// 	description: 'Den har bilen har fyrhjulsdrift for battre grepp och stabilitet i olika vagforhallanden.'
	// },
	// {
	// 	keyword: '7-sits',
	// 	aliases: ['7-sits', '7 sits', 'sjusits'],
	// 	title: '7-sits',
	// 	description: 'Den har bilen erbjuder plats for upp till sju personer.'
	// }
];

const normalize = (value = '') => value.toLowerCase().replace(/[^a-z0-9]/g, '');

const toKeywordSet = (keywords = '') => {
	return new Set(
		keywords
			.split(/\s+/)
			.map(normalize)
			.filter(Boolean)
	);
};

const getMatchingKeywordBlocks = (keywords = '') => {
	const keywordSet = toKeywordSet(keywords);
	const normalizedKeywordString = normalize(keywords);

	return keywordConfig.filter(({ keyword, aliases = [] }) => {
		const searchTerms = [keyword, ...aliases].map(normalize).filter(Boolean);
		return searchTerms.some((term) => keywordSet.has(term) || normalizedKeywordString.includes(term));
	});
};

const KeywordSection = ({ carKeywords }) => {
	const matchingKeywords = getMatchingKeywordBlocks(carKeywords);

	if (!matchingKeywords.length) {
		return null;
	}

	return (
		<div className="section keyword-section">
			{matchingKeywords.map((item) => (
				<div key={item.keyword} className={`keyword-wrapper ${normalize(item.keyword)}`}>
					<h3 className="keyword-title">{item.title}</h3>
					<p className="keyword-description">{item.description}</p>
				</div>
			))}
		</div>
	);
};

export default KeywordSection;
